import React, { useEffect } from 'react';
import { RiInboxArchiveLine } from "react-icons/ri";
import { BiHide } from "react-icons/bi";
import { useDispatch, useSelector } from 'react-redux';
import { getVMAccountForRPName } from '../../utils/utils';
import { getVoicemailList } from '../../utils/awsAPI';
import { voicemailSliceAction } from '../../store/voicemailSilce';

const VoicemailList = () => {
    const dispatch = useDispatch()
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const selectedTab = useSelector((state:any)=>{return state.voicemailSilce.selectedTab})
    const counts = useSelector((state:any)=>{return state.voicemailSilce.counts})

    useEffect(() => {
        getVoicemailData();
    },[])

    const getVoicemailData = async () => {
        if(agentObj) {
            let profileName = agentObj?.getRoutingProfile()?.name || "";
            let vmProfileName = await getVMAccountForRPName(profileName)
            if(vmProfileName) {
                let voicemailList = await getVoicemailList(vmProfileName)
                let inboxVoicemail = voicemailList.voicemail_table.filter((item:any) => !(item?.Hidden)).length || 0
                let hiddenVoicemail = voicemailList.voicemail_table.filter((item:any) => item?.Hidden).length || 0
                dispatch(voicemailSliceAction.setVoicemailData(voicemailList))
                dispatch(voicemailSliceAction.setCounts({inbox:inboxVoicemail,hidden:hiddenVoicemail}))
            }
        }
    }

    const onTabChange = (tabName:any) => {
        dispatch(voicemailSliceAction.setSelectedTab(tabName))
    }

    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="ChatWrapup">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Voicemails</h6>
                </div>
                <div className="card-body height-400">
                    <ul className='mailbox-list list-unstyled'>
                        <li><button onClick={()=>{onTabChange("Inbox")}} className={`${(selectedTab === 'Inbox') ? `active-mailbox` : ``}`}><RiInboxArchiveLine /> Inbox (<span className='count'>{counts.inbox}</span>)</button></li>
                        <li><button onClick={()=>{onTabChange("Hidden")}} className={`${(selectedTab === 'Hidden') ? `active-mailbox` : ``}`}><BiHide /> Hidden (<span className='count'>{counts.hidden}</span>)</button></li>                        
                    </ul>
                </div>
            </div>
        </React.Fragment>
    )
}
export default VoicemailList;